import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string().min(1),
    slug: z.string().min(1),
    publishedAt: z.string().nullable(),
    img: z.object({
      data: z.object({
        id: z.number(),
        attributes: z.object({
          url: z.string().min(1),
        }),
      }),
    }),
    short_description: z.string().min(1).optional(),
    cottages: z
      .array(
        z.object({
          id: z.number(),
          __component: z.string().min(1),
          title: z.string().min(1),
          facets: z.string().min(1),
          cta_text: z.string().min(1),
          cta_link: z.string().min(1),
        }),
      )
      .optional(),
    blog_posts: z
      .object({
        id: z.number(),
        title: z.string().min(1),
        slugs: z.string().nullable(),
      })
      .optional(),
    long_description: z
      .object({
        id: z.number(),
        title: z.string().min(1),
        text: z.string().min(1),
      })
      .optional(),
  }),
})

export type schemaType = z.infer<typeof schema>

export type attributesCottageType = Exclude<
  schemaType['attributes']['cottages'],
  null | undefined
>[number]

export const paramsSchema = z.object({
  slug: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
